import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

const CarpetInstall = createSvgIcon(
  <path d="M24 14.25V3.747A3.748 3.748 0 0 0 20.25 0a3.75 3.75 0 0 0-3.675 3H0v15h20.25A3.75 3.75 0 0 0 24 14.25ZM18.75 3.748c0-.827.67-1.498 1.5-1.498s1.5.67 1.5 1.497v7.065c-.46-.2-.967-.312-1.5-.312h-1.5V3.748ZM16.5 5.25v7.5h3.75a1.5 1.5 0 0 1 0 3h-18V5.25H16.5ZM2.25 21.75h8.625V19.5h2.25v2.25h8.625V19.5H24V24H0v-4.5h2.25v2.25Z" />,
  'CarpetInstall'
);

export { CarpetInstall };